var map = {
	"./_design-tokens_BDFR.json": 5123,
	"./_design-tokens_BQUK.json": 8983,
	"./_design-tokens_CAFR.json": 2514,
	"./_design-tokens_SFUK.json": 5825,
	"./_design-tokens_TPUK.json": 5727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2616;